import React from "react";
import { DataGrid } from "devextreme-react";
import uri from "../../utils/uri";
import { store } from "../../services/store";
import { Column, Editing, Paging, Popup } from "devextreme-react/data-grid";
import BlockHeader from '../../components/shared/BlockHeader';
import Title from "../../components/shared/Title";
import { formatPad } from "../../utils/common";

const CorrectionContacts = props => {

    const onCellPrepared = e => {

        if (e.rowType == 'data') {

            if (e.column.dataField == "negativo")
                e.cellElement.classList.add('negative');

        }

    }

    const title = "Tabla de conversion Lentes Toricos";

    return (
        <div className="container small">
            <Title title={title} />
            <BlockHeader title={title} />
            <DataGrid
                dataSource={store({ uri: uri.correctionContacts })}
                showBorders={true}
                showRowLines={true}
                onCellPrepared={onCellPrepared}
            >
                <Paging defaultPageSize={22} />
                <Editing
                    mode="cell"
                    allowUpdating={true}
                    allowDeleting={false}
                    allowAdding={false}
                    useIcons={true}

                >
                    <Popup width={600} height={200}>
                    </Popup>                    
                </Editing>
                <Column dataField="correction" caption="Correcion" allowEditing={false} cellRender={formatPad} />
                <Column dataField="positivo" caption="Positivo" cellRender={data => `+${formatPad(data)}`} />
                <Column dataField="negativo" caption="Negativo" cellRender={data => `-${formatPad(data)}`} />
            </DataGrid>

        </div>
    );
}

export default CorrectionContacts;